import { ErrorItem } from '../components/ErrorsPresenter/ErrorsPresenter';
import { BannersPriceField } from '../typings/bannerPricesPopupState';
import { EditorBannerPriceId } from '../typings/bannersEditState';

/* Открытие попапа цены(массовое редактирование баннеров) */
export const OPEN_BANNERS_PRICES_POPUP = 'OPEN_BANNERS_PRICES_POPUP';
export type OPEN_BANNERS_PRICES_POPUP = typeof OPEN_BANNERS_PRICES_POPUP;

export interface OpenBannersPricesPopup {
    type: OPEN_BANNERS_PRICES_POPUP;
    bannerId: EditorBannerPriceId;
}

export function openBannersPricesPopup(
    bannerId: EditorBannerPriceId
): OpenBannersPricesPopup {
    return {
        type: OPEN_BANNERS_PRICES_POPUP,
        bannerId
    };
}

/* Закрытие попапа цен(массовое редактирование баннеров) */
export const CLOSE_BANNERS_PRICES_POPUP = 'CLOSE_BANNERS_PRICES_POPUP';
export type CLOSE_BANNERS_PRICES_POPUP = typeof CLOSE_BANNERS_PRICES_POPUP;

export interface CloseBannersPricesPopup {
    type: CLOSE_BANNERS_PRICES_POPUP;
    bannerId: EditorBannerPriceId;
}

export function closeBannersPricesPopup(
    bannerId: EditorBannerPriceId
): CloseBannersPricesPopup {
    return {
        type: CLOSE_BANNERS_PRICES_POPUP,
        bannerId
    };
}

/* Переключение режимов в попапе цен(массовое редактирование баннеров) */
export const SWITCH_BANNERS_PRICES_POPUP_FORM =
    'SWITCH_BANNERS_PRICES_POPUP_FORM';
export type SWITCH_BANNERS_PRICES_POPUP_FORM = typeof SWITCH_BANNERS_PRICES_POPUP_FORM;

export interface SwitchBannersPricesPopupForm {
    type: SWITCH_BANNERS_PRICES_POPUP_FORM;
    bannerId: EditorBannerPriceId;
}

export function switchBannersPricesPopupForm(
    bannerId: EditorBannerPriceId
): SwitchBannersPricesPopupForm {
    return {
        type: SWITCH_BANNERS_PRICES_POPUP_FORM,
        bannerId
    };
}

/* Обновление попапа цен(массовое редактирование баннеров) */
export const UPDATE_BANNERS_PRICES_POPUP = 'UPDATE_BANNERS_PRICES_POPUP';
export type UPDATE_BANNERS_PRICES_POPUP = typeof UPDATE_BANNERS_PRICES_POPUP;

export interface UpdateBannersPricesPopup {
    type: UPDATE_BANNERS_PRICES_POPUP;
    changed: {
        field: BannersPriceField;
        value: string;
    };
    paths?: Array<string>;
    bannerId: EditorBannerPriceId;
}

export function updateBannersPricesPopup(
    changed: {
        field: BannersPriceField;
        value: string;
    },
    bannerId: EditorBannerPriceId,
    paths?: Array<string>
): UpdateBannersPricesPopup {
    return {
        type: UPDATE_BANNERS_PRICES_POPUP,
        changed,
        paths,
        bannerId
    };
}

/* Обновление ошибок в попапе цен(массовое редактирование баннеров) */
export const UPDATE_BANNERS_PRICES_POPUP_ERRORS =
    'UPDATE_BANNERS_PRICES_POPUP_ERRORS';
export type UPDATE_BANNERS_PRICES_POPUP_ERRORS = typeof UPDATE_BANNERS_PRICES_POPUP_ERRORS;

export interface UpdateBannersPricesPopupErrors {
    type: UPDATE_BANNERS_PRICES_POPUP_ERRORS;
    errors: ErrorItem[];
    bannerId: EditorBannerPriceId;
}

export function updateBannersPricesPopupErrors(
    errors: ErrorItem[],
    bannerId: EditorBannerPriceId
): UpdateBannersPricesPopupErrors {
    return {
        type: UPDATE_BANNERS_PRICES_POPUP_ERRORS,
        errors,
        bannerId
    };
}

/* Валидация цен(массовое редактирование баннеров) */
export const VALIDATE_BANNERS_PRICES = 'VALIDATE_BANNERS_PRICES';
export type VALIDATE_BANNERS_PRICES = typeof VALIDATE_BANNERS_PRICES;

export interface ValidateBannersPrices {
    type: VALIDATE_BANNERS_PRICES;
    bannerId: EditorBannerPriceId;
}

export function validateBannersPrices(
    bannerId: EditorBannerPriceId
): ValidateBannersPrices {
    return {
        type: VALIDATE_BANNERS_PRICES,
        bannerId
    };
}

/* Сохранение цен(массовое редактирование баннеров) */
export const SAVE_BANNERS_PRICES = 'SAVE_BANNERS_PRICES';
export type SAVE_BANNERS_PRICES = typeof SAVE_BANNERS_PRICES;

export interface SaveBannersPrices {
    type: SAVE_BANNERS_PRICES;
    bannerId: EditorBannerPriceId;
}

export function saveBannersPrices(
    bannerId: EditorBannerPriceId
): SaveBannersPrices {
    return {
        type: SAVE_BANNERS_PRICES,
        bannerId
    };
}

/* Удаление цен(массовое редактирование баннеров) */
export const RESET_BANNERS_PRICES = 'RESET_BANNERS_PRICES';
export type RESET_BANNERS_PRICES = typeof RESET_BANNERS_PRICES;

export interface ResetBannersPrices {
    type: RESET_BANNERS_PRICES;
    bannerId: EditorBannerPriceId;
}

export function resetBannersPrices(
    bannerId: EditorBannerPriceId
): ResetBannersPrices {
    return {
        type: RESET_BANNERS_PRICES,
        bannerId
    };
}

export type BannersPricesEditPopupAction =
    | OpenBannersPricesPopup
    | CloseBannersPricesPopup
    | UpdateBannersPricesPopup
    | SwitchBannersPricesPopupForm
    | UpdateBannersPricesPopupErrors
    | ResetBannersPrices
    | ValidateBannersPrices
    | SaveBannersPrices;
